module.exports = __webpack_public_path__ + "static/media/Saving.83b00f39.svg";